// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__vQqLz","form":"styles_form__2xMtx"};